import React, { FC } from 'react';

import { defineMessages, useIntl } from 'react-intl';

import Modal from 'components/modal';
import Picture from 'components/picture';
import { ContentContainer } from 'components/store-card-icons/styled';
import { useFeatureLayout } from 'hooks/use-feature-layout';

import { GeolocationImageContainer, HeaderCaption, ModalButton, ModalButtonAlt } from './styled';
import { IGeolocationModalViewProps } from './types';

const messages = defineMessages({
  ourRestaurantsNearYou: {
    id: 'ourRestaurantsNearYou',
    defaultMessage: 'Our restaurants near you',
    description: 'Sub header text'
  },
  allowLocationServices: {
    id: 'allowLocationServices',
    defaultMessage: 'Allow location services',
    description: 'Button text to allow location services'
  },
  allowLocationServicesToFind: {
    id: 'allowLocationServicesToFind',
    defaultMessage: 'Allow location services to find',
    description: 'Title for modal (precedes our restaurants near you)'
  },
  selectManually: {
    id: 'selectManually',
    defaultMessage: 'Select Manually',
    description: 'Button text for select manually'
  }
});

export const GeolocationModalView: FC<IGeolocationModalViewProps> = ({
  dismissModal,
  handleGeolocationPrompt,
  selectManually
}) => {
  const { formatMessage } = useIntl();
  const { featureLayout } = useFeatureLayout();
  const imageId = featureLayout?.geolocationModalImage?.locale;
  const modalHeading = formatMessage(messages.allowLocationServicesToFind);
  const allowLocationServices = formatMessage(messages.allowLocationServices);

  return (
    <Modal
      onDismiss={dismissModal}
      mParticleEventData={{
        modalAppearanceEventMessage: 'Allow location services'
      }}
      data-testid="geolocation-modal"
    >
      <ContentContainer>
        <HeaderCaption>
          <h5 data-testid="modal-heading" id="modal-heading">
            {modalHeading}
          </h5>
          <h2>{formatMessage(messages.ourRestaurantsNearYou)}</h2>
        </HeaderCaption>
        <GeolocationImageContainer>
          {!!imageId && <Picture image={imageId} alt={allowLocationServices} />}
        </GeolocationImageContainer>
        <ModalButton data-testid="geolocation-allow" onClick={handleGeolocationPrompt}>
          {allowLocationServices}
        </ModalButton>
        <ModalButtonAlt data-testid="geolocation-manual" onClick={selectManually}>
          {formatMessage(messages.selectManually)}
        </ModalButtonAlt>
      </ContentContainer>
    </Modal>
  );
};
